import { render } from "./button.vue?vue&type=template&id=1dc9420e&scoped=true"
import script from "./button.vue?vue&type=script&lang=ts"
export * from "./button.vue?vue&type=script&lang=ts"

import "./button.vue?vue&type=style&index=0&id=1dc9420e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1dc9420e"

export default script